import { useRoutes } from '@folklore/routes';
import React from 'react';
import { Route, Switch } from 'wouter';

import useMicromags from '../hooks/useMicromags';

import { MicromagItem } from '../types/micromag';
import MainLayout from './layouts/Main';
import HomePage from './pages/Home';
import MicromagPage from './pages/Micromag';
import TextPage from './pages/Text';

import accessibility from '../data/accessibility.html';
import legal from '../data/legal.html';

interface RoutesProps {
    micromags?: MicromagItem[] | null;
    loading?: boolean;
}

function Routes({ micromags: initialMicromags = null, loading = false }: RoutesProps) {
    const routes = useRoutes() || {};
    const micromags = useMicromags(initialMicromags);

    return (
        <Switch>
            <Route path={routes.home}>
                <MainLayout>
                    <HomePage micromags={micromags} />
                </MainLayout>
            </Route>
            <Route path={routes.legal}>
                <MainLayout>
                    <TextPage title="Mentions légales" content={legal} />
                </MainLayout>
            </Route>
            <Route path={routes.accessibility}>
                <MainLayout>
                    <TextPage title="Déclaration d’accessibilité" content={accessibility} />
                </MainLayout>
            </Route>
            <Route path="/:micromag">
                {({ micromag = null }) => {
                    const current = (micromags || []).find((it) => it.slug === micromag) || null;
                    return (
                        <MainLayout fullScreen>
                            <MicromagPage micromags={micromags} micromag={current} hasHome />
                        </MainLayout>
                    );
                }}
            </Route>
            <Route path="/:micromag/:screen">
                {({ micromag = null, screen = null }) => {
                    const current = (micromags || []).find((it) => it.slug === micromag) || null;
                    return (
                        <MainLayout fullScreen>
                            <MicromagPage
                                micromags={micromags}
                                micromag={current}
                                screen={screen}
                                hasHome
                            />
                        </MainLayout>
                    );
                }}
            </Route>
        </Switch>
    );
}

export default Routes;
